import { asyncTimeout } from '@utils/common';

/**
 * Simlpe helper that ensures that all provided fonts, images etc. has been
 * fully loaded before resolving.
 */
async function waitForContent(root) {
  await Promise.race([asyncTimeout(10_000), Promise.all([waitForImages(root), waitForFonts(), asyncTimeout(50)])]).catch(err => {
    console.warn(err);
  });
}
async function waitForFonts() {
  await Promise.all(Array.from(document.fonts).map(font => font.load()));
}
async function waitForImages(root) {
  const images = [...root.querySelectorAll("img")];
  await Promise.all(images.map(img => new Promise(resolve => {
    img.loading = "eager";
    if (img.complete) {
      resolve();
    } else {
      img.addEventListener("load", () => resolve());
      img.addEventListener("abort", () => resolve());
      img.addEventListener("error", () => resolve());
    }
  })));
}

export { waitForContent };
//# sourceMappingURL=util.wait-for-content.js.map
